var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lessons-icon_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".lessons-icon_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.3px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "lessons-icon_svg__st0",
    d: "M7.8 7.3v-.8c0-.1.2-.2.3-.2.1 0 .3.1.7.3L13 9.3c.3.2.5.3.5.4v.3c0 .1-.2.2-.5.4l-4.2 2.7c-.4.2-.5.3-.7.3-.1 0-.2 0-.3-.2V7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "lessons-icon_svg__st0",
    d: "M2 6.3c0-1.5 0-2.2.3-2.8.3-.5.7-.9 1.2-1.2C4.1 2 4.8 2 6.3 2h7.5c1.5 0 2.2 0 2.8.3.5.3.9.7 1.2 1.2.3.6.3 1.3.3 2.8v7.5c0 1.5 0 2.2-.3 2.8-.3.5-.7.9-1.2 1.2-.6.3-1.3.3-2.8.3H6.3c-1.5 0-2.2 0-2.8-.3-.5-.3-.9-.7-1.2-1.2C2 16 2 15.3 2 13.8V6.3z"
  })));
}
export default SvgLessonsIcon;